import React, { useState } from 'react';
import { Modal, Form, Input, Select, Upload, message, Image } from 'antd';
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;

const SavePromptModal = ({ visible, onCancel, onSave, title = "Save Prompt", initialValues = {} }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState([]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            await onSave({ ...values, files: fileList.map(f => f.originFileObj || f) });
            message.success('Prompt saved successfully');
            form.resetFields();
            setFileList([]);
            onCancel();
        } catch (error) {
            console.error('Failed to save prompt:', error);
            message.error('Failed to save prompt');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setFileList([]);
        onCancel();
    };

    const beforeUpload = (file) => {
        const isMedia = file.type.startsWith('image/') || file.type.startsWith('video/');
        if (!isMedia) {
            message.error('You can only upload image or video files');
            return Upload.LIST_IGNORE;
        }
        return false; // prevent auto-upload
    };

    const handleFileChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const handleRemoveFile = (file) => {
        setFileList(prev => prev.filter(f => f.uid !== file.uid));
    };

    return (
        <Modal
            title={title}
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={loading}
            destroyOnClose
            width={520}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={initialValues}
            >
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: 'Please enter a name for the prompt' }]}
                >
                    <Input placeholder="e.g., Creative Writing Assistant" />
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Description"
                >
                    <TextArea placeholder="Brief description of what this prompt does" rows={2} />
                </Form.Item>

                <Form.Item
                    name="tags"
                    label="Tags"
                >
                    <Select mode="tags" placeholder="Add tags (e.g., writing, creative, ai)">
                    </Select>
                </Form.Item>

                <Form.Item
                    name="content"
                    label="Prompt"
                    rules={[{ required: true, message: 'Please enter your prompt' }]}
                >
                    <TextArea
                        placeholder="Write your prompt here..."
                        rows={4}
                        style={{ background: '#0d1117', borderColor: '#30363d', color: '#e6edf3' }}
                    />
                </Form.Item>

                {/* Media Upload */}
                <Form.Item label="Media">
                    <Upload.Dragger
                        multiple
                        fileList={fileList}
                        beforeUpload={beforeUpload}
                        onChange={handleFileChange}
                        onRemove={handleRemoveFile}
                        accept="image/*,video/*"
                        listType="picture"
                        style={{
                            background: '#0d1117',
                            border: '1px dashed #30363d',
                            borderRadius: 8
                        }}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined style={{ color: '#58a6ff', fontSize: 32 }} />
                        </p>
                        <p className="ant-upload-text" style={{ color: '#c9d1d9', fontSize: 13 }}>
                            Drop images or videos here, or click to browse
                        </p>
                        <p className="ant-upload-hint" style={{ color: '#8b949e', fontSize: 11 }}>
                            Supports images and video files
                        </p>
                    </Upload.Dragger>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SavePromptModal;
